import setItemState from "./setItemState";
import { ITEM_STATE_DELETING } from "../../constants";

export default (state, { payload: { id } }) => ({
  ...setItemState(state, id, ITEM_STATE_DELETING)
});
